import { useState } from 'react'

import Box from '@mui/material/Box'
import type { ButtonProps } from '@mui/material/Button'
import Button from '@mui/material/Button'
import ClickAwayListener from '@mui/material/ClickAwayListener'

export { ConfirmButton }

type Props = ButtonProps & {
  onConfirm: () => void
}

const ConfirmButton = ({ onConfirm, children, ...rest }: Props) => {
  const [confirm, setConfirm] = useState(false)

  const onClickAway = () => {
    setConfirm(false)
  }

  return confirm ? (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button variant="text" onClick={onClickAway}>
        Annuleren
      </Button>

      <ClickAwayListener onClickAway={onClickAway}>
        <Button
          {...rest}
          onClick={() => {
            onConfirm()
            setConfirm(false)
          }}
        >
          Bevestigen
        </Button>
      </ClickAwayListener>
    </Box>
  ) : (
    <Button {...rest} onClick={() => setConfirm(true)}>
      {children}
    </Button>
  )
}
